var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"background-image"}},[_c('v-fade-transition',{attrs:{"leave-absolute":""}},[_c('v-img',{key:_vm.image,attrs:{"src":_vm.image,"height":"100%","position":"center bottom","transition":"fade-transition"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }